// extracted by mini-css-extract-plugin
module.exports = {"container":"PendingBalance_container__2vA67","messageBox":"PendingBalance_messageBox__1wtbW"};